<span class="crop" [innerHTML]="textStart()"></span>
<span [innerHTML]="textEnd()"></span>
